import OnGoingStudentQuestions from "./OnGoingStudentQuestions";

const StudentQuestions = {OnGoing: OnGoingStudentQuestions}
export default StudentQuestions;